import { useEffect } from 'react'
import { useAppDispatch, useAppSelector } from '../../../hooks/redux'
import { setResponseWarningShow } from '../../../store/reducers/app/ResponseInfoSlices'
import ResponseWarning from './ResponseWarning'

let ResponseWarningContainer = () => {

    const dispatch = useAppDispatch()

    const warning = useAppSelector<number | null>(state => state.responseInfo.warning)
    const warningShow = useAppSelector<boolean>(state => state.responseInfo.warningShow)

    
    useEffect(
        () => {
            if(warningShow){
                setTimeout(() => {
                    dispatch(setResponseWarningShow(false))
                }, 3000)
            }
        }, [dispatch, warningShow]
    )

    return (
        <>
            {warningShow
                ?
                    <ResponseWarning
                        warning={warning}
                    />
                : null
            }
        </>
    )
}

export default ResponseWarningContainer